import PropTypes from 'prop-types';
import React from 'react';

var TableSelect = function TableSelect(_ref) {
  var checked = _ref.checked,
      id = _ref.id,
      row = _ref.row,
      selectType = _ref.selectType,
      _onClick = _ref.onClick;
  var input = React.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, React.createElement("input", {
    checked: checked || false,
    style: {
      marginTop: 0
    },
    type: selectType,
    onClick: function onClick(e) {
      var shiftKey = e.shiftKey;
      e.stopPropagation();

      _onClick(id, shiftKey, row);
    },
    onChange: function onChange() {}
  }));
  return input;
};

TableSelect.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.string,
  row: PropTypes.objectOf(PropTypes.any),
  selectType: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
export default TableSelect;